















import { defineComponent, computed, PropType } from '@vue/composition-api';
import { useContext } from '@berlin-front/common/composables/context';
import useCss from '@berlin-front/common/composables/useCss';
import { ThemeContext } from '@berlin-front/common/services/ThemeContext';

export default defineComponent({
  name: 'AppFramedRadioGroup',

  model: {
    event: 'select',
    prop: 'value',
  },

  props: {
    value: {
      type: [String, Number, Boolean] as PropType<string | number | boolean>,
      required: true,
    },

    items: {
      type: [String, Number, Boolean] as PropType<string | number | boolean>,
      required: true,
    },
  },

  emits: [
    /**
     * ラジオグループ内の別選択肢が選択された時に呼び出される。
     */
    'select',
  ],

  setup(props, context) {
    const { themeParameter } = useContext(ThemeContext);
    const primaryColor = computed(() => themeParameter.value.primaryColor);

    const model = computed({
      get: () => props.value,
      set: (value) => context.emit('select', value),
    });

    useCss(
      () => `
        .v-radio.v-item--active {
          border-color: ${primaryColor.value};
        }
        .v-item--active {
          .AppFramedRadio__Radio {
            border-color: ${primaryColor.value};
          }
          .AppFramedRadio__Radio::after {
            background: ${primaryColor.value};
          }
        }
      `,
    );

    return {
      model,
    };
  },
});
